import { baseUrl } from "@/config/env";
import request from "@/router/axios";

const batchUrl = `${baseUrl}/joins-sales-cloud/v1/customs_declaration/financeExportBatch`;

const parseResponseData = response => {
  let data = response;
  for (let depth = 0; depth < 4; depth++) {
    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
        continue;
      } catch (error) {
        return data;
      }
    }
    if (!data || typeof data !== "object") {
      return data;
    }
    if (Object.prototype.hasOwnProperty.call(data, "code") && String(data.code) !== "200") {
      const error = new Error(data.message || "财务导出请求失败");
      error.code = data.code;
      throw error;
    }
    if (Object.prototype.hasOwnProperty.call(data, "data")) {
      data = data.data;
      continue;
    }
    return data;
  }
  return data;
};

const validateCreatedBatch = batch => {
  if (!batch || !batch.id || !batch.batchNo) {
    throw new Error("财务导出批次创建响应异常");
  }
  return batch;
};

const validateBatchId = id => {
  if (!id || id === "undefined" || id === "null") {
    return Promise.reject(new Error("财务导出批次ID无效"));
  }
  return null;
};

export const createFinanceExportBatch = data => request({
  url: batchUrl,
  method: "POST",
  data,
  timeout: 100000
}).then(parseResponseData).then(validateCreatedBatch);

export const getFinanceExportBatchPage = params => request({
  url: batchUrl,
  method: "GET",
  params
}).then(parseResponseData);

export const downloadFinanceExportBatch = id => {
  const invalid = validateBatchId(id);
  return invalid || request({
    url: `${batchUrl}/${id}/download`,
    method: "GET",
    responseType: "blob",
    timeout: 100000
  });
};

export const confirmFinanceExportBatch = id => {
  const invalid = validateBatchId(id);
  return invalid || request({
    url: `${batchUrl}/${id}/confirm`,
    method: "PUT",
    data: {}
  }).then(parseResponseData);
};

export const cancelFinanceExportBatch = id => {
  const invalid = validateBatchId(id);
  return invalid || request({
    url: `${batchUrl}/${id}/cancel`,
    method: "PUT",
    data: {}
  }).then(parseResponseData);
};
